module.exports = __webpack_public_path__ + "img/cambodia.44e7cc5c.svg";